import { render, staticRenderFns } from "./two-step-verification-2.vue?vue&type=template&id=4b21c502&"
import script from "./two-step-verification-2.vue?vue&type=script&lang=js&"
export * from "./two-step-verification-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports